import { render, staticRenderFns } from "./AppointmentMessagePreviewDialog.vue?vue&type=template&id=6dff2a64&scoped=true"
import script from "./AppointmentMessagePreviewDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentMessagePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./AppointmentMessagePreviewDialog.vue?vue&type=style&index=0&id=6dff2a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff2a64",
  null
  
)

export default component.exports